/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FileAddFileUploadRequest } from "../models/FileAddFileUploadRequest";
import type { FileAddFileUploadResponseApiRespoonse } from "../models/FileAddFileUploadResponseApiRespoonse";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class FileManagementService {
  /**
   * Add new file upload
   * @param requestBody
   * @returns FileAddFileUploadResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static filesAddFileUpload(
    requestBody: FileAddFileUploadRequest
  ): CancelablePromise<FileAddFileUploadResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/files/add-file-upload",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }
}
